import React from "react";
import { Link } from "react-router-dom";
import "./css/GamingPortfolio.css";

const GAMES = [
  {
    title: "Last Shot",
    status: "RELEASED",
    statusColor: "#00ff88",
    link: "https://felippefn.itch.io/last-shot",
    desc: "This is your Last Shot. Fight and survive!",
    imageUrl: "https://img.itch.zone/aW1hZ2UvMzczMzQ2NS8yMjIyMTE0Mi5wbmc=/794x1000/Q8ZOoq.png",
    tags: ["Action", "2D", "Survival"],
    color: "#ff0055",
  },
  {
    title: "Escape Shifter",
    status: "RELEASED",
    statusColor: "#00ff88",
    link: "https://felippefn.itch.io/escape-shifter",
    desc: "What if escaping a prison wasn't about strength, but evolution?",
    imageUrl: "https://img.itch.zone/aW1nLzIxOTI2OTgyLnBuZw==/315x250%23c/Q5VLWz.png",
    tags: ["Puzzle", "Stealth", "Indie"],
    color: "#00ccff",
  },
  {
    title: "Cat's Life Game",
    status: "IN PROGRESS",
    statusColor: "#ffcc00",
    link: "https://github.com/Felippefn/CatsLifeGame",
    desc: "Be a cat, solve puzzles, hide.",
    imageUrl:
      "https://imagedelivery.net/WLUarKbmUXuuhDC7PG5_Qw/articles/c8426601a981185b735b73c92dd48dc2.jpeg/public",
    tags: ["Puzzle", "Casual", "WIP"],
    color: "#ff9900",
  },
  {
    title: "Apocalypse",
    status: "COMING SOON",
    statusColor: "#ff6600",
    link: null,
    desc: "Survive the apocalypse with strategic gameplay.",
    imageUrl:
      "https://dzamqefpotdvf.cloudfront.net/p/images/21b1e7a8-a3d1-4085-b85e-22c1e88c73c7_Own_basement_in_apocalypse.PNG",
    tags: ["Strategy", "Survival", "TBA"],
    color: "#ff3300",
  },
  {
    title: "Space Adventure",
    status: "ANNOUNCED",
    statusColor: "#aa66ff",
    link: null,
    desc: "Explore the universe and discover new worlds.",
    imageUrl:
      "https://shared.fastly.steamstatic.com/store_item_assets/steam/apps/2178820/ss_cd250dd317c6ea4a3c55c8379e2e2b481b568151.1920x1080.jpg?t=1669757355",
    tags: ["Adventure", "Space", "TBA"],
    color: "#9944ff",
  },
];

const GamingPortfolio = () => {
  return (
    <div className="gp-page">
      <div className="gp-scanlines" aria-hidden="true" />

      {/* ── HEADER ── */}
      <header className="gp-header">
        <Link to="/" className="gp-nav-link">◄ HOME</Link>
        <div className="gp-title-block">
          <p className="gp-eyebrow">{'// GAME_PORTFOLIO'}</p>
          <h1 className="gp-title">FN STUDIOS</h1>
          <p className="gp-subtitle">GAME DEVELOPER</p>
        </div>
        <a href="/about-me" className="gp-nav-link">WHO AM I? ►</a>
      </header>

      {/* ── FEATURED GAME ── */}
      <section className="gp-featured">
        <h2 className="gp-section-label">▶ PLAY LATEST GAME</h2>
        <div className="gp-iframe-frame">
          <iframe
            frameBorder="0"
            src="https://itch.io/embed-upload/14343350?color=010506"
            allowFullScreen
            title="Last Shot"
            className="gp-iframe-main"
          >
            <a href="https://felippefn.itch.io/last-shot">Play Last Shot on itch.io</a>
          </iframe>
        </div>
        <div className="gp-embed-row">
          <iframe
            frameBorder="0"
            src="https://itch.io/embed/3733465?bg_color=010506&fg_color=fff&link_color=628cff&border_color=fe0517"
            width="552"
            height="167"
            title="Last Shot Badge"
          >
            <a href="https://felippefn.itch.io/last-shot">Last Shot by Felippefn</a>
          </iframe>
          <iframe
            frameBorder="0"
            src="https://itch.io/embed/3683838?linkback=true&bg_color=050517&fg_color=eee&link_color=fa5c5c&border_color=363648"
            width="352"
            height="167"
            title="Escape Shifter"
          >
            <a href="https://felippefn.itch.io/escape-shifter">Escape Shifter on itch.io</a>
          </iframe>
        </div>
      </section>

      {/* ── GAMES GRID ── */}
      <section className="gp-games">
        <h2 className="gp-section-label">▶ ALL GAMES</h2>
        <div className="gp-grid">
          {GAMES.map((game, i) => (
            <a
              key={i}
              href={game.link ?? "#"}
              className={`gp-card${!game.link ? " gp-card--locked" : ""}`}
              target={game.link ? "_blank" : undefined}
              rel="noopener noreferrer"
              style={{ "--gc": game.color }}
              aria-disabled={!game.link}
            >
              <div className="gp-card-img-wrap">
                <img src={game.imageUrl} alt={game.title} className="gp-card-img" />
                <div className="gp-card-overlay" aria-hidden="true" />
              </div>
              <div className="gp-card-body">
                <div className="gp-card-top-row">
                  <h3 className="gp-card-title">{game.title}</h3>
                  <span className="gp-card-status" style={{ color: game.statusColor }}>
                    {game.status}
                  </span>
                </div>
                <p className="gp-card-desc">{game.desc}</p>
                <div className="gp-card-tags">
                  {game.tags.map((t, j) => (
                    <span key={j} className="gp-tag">{t}</span>
                  ))}
                </div>
              </div>
              <div className="gp-card-accent" aria-hidden="true" />
            </a>
          ))}
        </div>
      </section>

      <footer className="gp-footer">
        <span>© 2025 FN STUDIOS — ALL RIGHTS RESERVED</span>
      </footer>
    </div>
  );
};

export default GamingPortfolio;
